(function () {
    'use strict';

    angular
        .module('emails')
        .controller('SendSurveyPhysicalFairController', SendSurveyPhysicalFairController);

        SendSurveyPhysicalFairController.$inject = ['$scope','$uibModal','$compile','toastr','SendSurveyService'];

    function SendSurveyPhysicalFairController($scope,$uibModal,$compile,toastr,SendSurveyService) {
        var vm = this;

        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = 0;
        vm.to                     = [];
        vm.currentPage            = 1;
        vm.itemsPerPage           = [];
        vm.page                   = 1;

        vm.query                  = {};
        vm.title                  = "";
        vm.flag                   = false;
        vm.formatDate             = formatDate;
        vm.getAll                 = getAll;
        vm.physicalFairSelected    = [];
        vm.physicalFairs           = [];
        vm.openSendSurveyModal    = openSendSurveyModal;



        function activate(){
            vm.getAll(vm.currentPage);
        }

        function getAll(currentPage) {
            SendSurveyService.getPhysicalFairs(currentPage).then(function(response){
                vm.physicalFairs = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err) {
            });
        }

        function openSendSurveyModal(physicalFair) {

            $uibModal.open({
                templateUrl: 'templates/emails/sendSurveyPhysicalFair/modal/template.modal.html',
                controller: 'SurveyModalPhysicalFairController',
                controllerAs:'vm',
                resolve:
                {
                    physicalFair: function () {
                        return physicalFair;
                    },
                }
            });
        }

        function formatDate(date){
            return new Date(date);
        }

        /* Pagination */
        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }
        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getAll(vm.page);
        }

        activate();
    }

})();